module.exports = __webpack_public_path__ + "static/media/bg_blank_img.a44202a7.svg";